import {IntermediatePart} from "../../intermediatePart";

export default class TallCabinetLeg extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'tall_cabinet_leg';
    this.partName = 'Tall Cabinet Leg';
    this.translateId = "visualizer.kitchen.cabinet.tall_cabinet_leg";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

}
